import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import CircularProgress from '@material-ui/core/CircularProgress';

import useDataSource from 'Common/Utils/Hooks/useDataSource';
import { makeKeyGetter, makeLabelGetter, makeValueGetter } from 'Common/Utils/dataSourceHelpers';
import { hasValue } from 'utils';

function AsyncSelect({
    dataSource,
    keyField,
    value,
    valueField,
    labelField,
    onChange,
    onLoad,
    labelId,
    ...props
}) {
    const [{ data: items, isLoading }] = useDataSource(dataSource, null, onLoad);
    const keyGetter = useMemo(() => makeKeyGetter(keyField, valueField), [keyField, valueField]);
    const valueGetter = useMemo(() => makeValueGetter(valueField), [valueField]);
    const labelGetter = useMemo(() => makeLabelGetter(labelField, valueField), [labelField, valueField]);

    let menuItems = null;
    if (value && !items) {
        menuItems = [<MenuItem key={-1} value={value}>{value}</MenuItem>];
    } else if (isLoading) {
        menuItems = [<MenuItem key={-1} value="" disabled><CircularProgress color="inherit" size={14} />&nbsp;Loading...</MenuItem>];
    } else if (items) {
        menuItems = !hasValue(value) ? [<MenuItem key={-1} value="" disabled>Select</MenuItem>] : [];
        menuItems.push(...items.map((item, index) => (
            <MenuItem key={keyGetter(item, index)} value={valueGetter(item)}>{labelGetter(item)}</MenuItem>
        )));
    }

    return (
        <Select
            {...props}
            value={value || ''}
            displayEmpty
            onChange={onChange}
            labelId={labelId}
        >
            {menuItems}
        </Select>
    );
}

AsyncSelect.propTypes = {
    dataSource: PropTypes.instanceOf(Promise).isRequired,
    keyField: PropTypes.string,
    labelField: PropTypes.string,
    value: PropTypes.any,
    valueField: PropTypes.string,
    onChange: PropTypes.func,
    onLoad: PropTypes.func
};

export default AsyncSelect;
